export default __webpack_public_path__ + "static/media/process.1854c4e4.svg";